const ContentCreator = ({creator}) => {

    return (
      <div className='mt-4'>
          {creator?.[0]?.is_company ? 
          <div className='flex flex-col md:items-start items-end'>
              <p className='text-xs -mb-1 font-semibold'>Course co-certified by</p>
              <div className='w-[80px] h-auto flex'>
                  <img src={creator?.[0]?.company_details?.company_image?.url} alt="company image" className='w-full h-auto object-cover' />
              </div>
          </div> : 
          <div className='flex flex-col lg:items-start'> 
              <p className='text-[11px] md:text-xs font-medium'>Co-certified by {window.innerWidth < 640 ? creator?.[0]?.creator_name.length < 14 ? creator?.[0]?.creator_name : creator?.[0]?.creator_name.slice(0, 13) + '...' : creator?.[0]?.creator_name}</p>
              <div className='flex'>
                  <div className='w-[40px] h-[40px]'>
                      <img src={creator?.[0]?.creator_image?.url} alt="company image" className='w-full h-full object-cover rounded-full'/>
                  </div>
                  <div className='flex flex-col ml-2'>
                      <p className='text-[10px] md:text-xs font-semibold'>{window.innerWidth < 640 ? creator?.[0]?.creator_designation.length < 22 ?creator?.[0]?.creator_designation : creator?.[0]?.creator_designation.slice(0, 21) + '...' : creator?.[0]?.creator_designation} at</p>
                      <div className='w-[70px] h-auto'>
                          <img src={creator?.[0]?.company_details?.company_image?.url} alt="company image" className='w-full h-auto object-cover' />
                      </div>
                  </div>
              </div>  
          </div>    
      } 
      </div>
    )
  }
  
  export default ContentCreator